import { render, staticRenderFns } from "./NavExternalLink.vue?vue&type=template&id=a3afa396&scoped=true"
import script from "./NavExternalLink.vue?vue&type=script&lang=js"
export * from "./NavExternalLink.vue?vue&type=script&lang=js"
import style0 from "./NavExternalLink.vue?vue&type=style&index=0&id=a3afa396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3afa396",
  null
  
)

export default component.exports